import React, { VFC, useEffect, useState } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import { RecommendedColumn } from '/components/BlockColumns/RecommendedColumn';
import {
  ArticleBlockProps,
  BlockContentJson,
  ColumnContainerJson,
  ColumnsJson,
  TrackRecommendedContentFn,
} from '/types';
import { useCwaAxios } from '/utils/cwaAxios';
import useTranslate from '/utils/translations';

import styles from './BlockRecommendedContent.scss';

type RelatedItemsApiResponse = RelatedItemsApiSuccess | null;

type RelatedItemsData = {
  title: string;
  date: string;
  source: string;
  url: string;
  contentType?: string;
  slug?: string;
  article_image_url: string;
};

type RelatedItemsApiSuccess = {
  data: RelatedItemsData[];
};

type BlockRecommendedContentProps = {
  articleId: string;
  trackRecommendedContent: TrackRecommendedContentFn;
};

const BlockRecommendedContent: VFC<BlockRecommendedContentProps> = ({
  articleId,
  trackRecommendedContent,
}) => {
  const t = useTranslate();

  const [apiResponse, setApiResponse] = useState(
    null as RelatedItemsApiResponse,
  );

  const cwaAxios = useCwaAxios();

  useEffect(() => {
    cwaAxios
      .get(`/api/content/related-items/${articleId}`)
      .then((resp) => setApiResponse(resp.data));
  }, [cwaAxios, articleId, setApiResponse]);

  if (apiResponse) {
    const columnData = apiResponse.data.map((data) => {
      const elements = {
        title: data.title,
        image: data.article_image_url,
        date: data.date,
        source: data.source,
        url: data.url,
        contentType: data.contentType,
        slug: data.slug,
      };

      const column: ColumnContainerJson = {
        elements: elements,
        hidden: false,
        name: 'recommended',
        type: 'container',
      };
      return column;
    });

    const columns: ColumnsJson = {
      layout: 'equal',
      hidden: false,
      type: 'list',
      list: columnData,
    };

    const blockContent: BlockContentJson = {
      title: {
        hidden: false,
        type: 'html',
        content: t('You might also be interested in...'),
      },
      columns: columns,
    };

    const blockProps: ArticleBlockProps = {
      blockId: '1-block-recommended-content',
      blockBackgroundType: 'bg-grey',
      blockContent: blockContent,
      blockBackgroundOpacity: '0.0',
      blockType: 'block-recommended-content',
      blockLinked: false,
    };

    return (
      <div className={styles['recommended-content']}>
        <ArticleBlock
          {...blockProps}
          titleCentered
          offset={1}
          columns={columns.list.map((column: ColumnContainerJson) => (
            <>
              {column.name === 'recommended' && (
                <RecommendedColumn
                  elements={column.elements}
                  trackRecommendedContent={trackRecommendedContent}
                />
              )}
            </>
          ))}
        />
      </div>
    );
  }

  return <></>;
};

export default BlockRecommendedContent;
